module.exports = false;


/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/_library.js
 **/